import { render, staticRenderFns } from "./e-input-file.vue?vue&type=template&id=86e85ec0&scoped=true&lang=pug&"
import script from "./e-input-file.vue?vue&type=script&lang=js&"
export * from "./e-input-file.vue?vue&type=script&lang=js&"
import style0 from "./e-input-file.vue?vue&type=style&index=0&id=86e85ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e85ec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
